/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Combousers from './combousers';
import CombousersDetail from './combousers-detail';
import CombousersUpdate from './combousers-update';
import CombousersDeleteDialog from './combousers-delete-dialog';

const CombousersRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Combousers />} />
    <Route path="new" element={<CombousersUpdate />} />
    <Route path=":id">
      <Route index element={<CombousersDetail />} />
      <Route path="edit" element={<CombousersUpdate />} />
      <Route path="delete" element={<CombousersDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CombousersRoutes;
